<lin-chat-details-user-list
  [currentChat]="selectedChat$ | async"
  [isGroupChat]="isGroupChat"
  [isMyChat]="isMyChat"
  [currentUser]="currentUser"
></lin-chat-details-user-list>
<lin-chat-message-list
  [currentUser]="currentUser"
  [chatMessageList]="chatMessageList$ | async"
  [isGroupChat]="isGroupChat"
  [isMyChat]="isMyChat"
  [isAttachment]="isAttachment"
></lin-chat-message-list>
<lin-chat-form
  *ngIf="isMyChat"
  [chatId]="chatId"
  [currentUser]="currentUser"
  [typing]="typing | async"
  (handleTyping)="handleTyping($event)"
  (isAttachment)="isAttachment = $event"
></lin-chat-form>
<button
  class="unread-container"
  [ngClass]="{'with-counter': !!unreadCurrentChatCount}"
  *ngIf="(isScrollBottom$ | async) === false"
  (click)="messengerService.triggerScrollToBottom()"
>
  <div class="unread-container__count" *ngIf="unreadCurrentChatCount">{{ unreadCurrentChatCount }}</div>
  <mat-icon svgIcon="arrow_downward"></mat-icon>
</button>
